// extracted by mini-css-extract-plugin
export default {"avatarOverlay":"ProductCatalog_avatarOverlay__L+A5a"};